var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:this.disabled ? 'disabled' : null,attrs:{"title":_vm.titleText},on:{"mousedown":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }